<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
       <div class="mt-goods-top" style="height: auto;">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="商品分类：">
            <el-cascader
              placeholder="请选择"
              :options="cateOptions"
              @change="searchCateChangeBtn"
              filterable></el-cascader>
          </el-form-item>
          <el-form-item label="商品名称：">
            <el-input v-model="searchForm.name" placeholder="请输入商品名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchTopBtn">查询</el-button>
            <el-button @click="enableGoodsStatusBtn(multipleSelection,0)" v-loading.fullscreen.lock="fullscreenLoading">批量下架</el-button>
            <el-button @click="enableGoodsStatusBtn(multipleSelection,1)" v-loading.fullscreen.lock="fullscreenLoading">批量上架</el-button>
          </el-form-item>
        </el-form>
        <el-button @click="editBtn('')" v-loading.fullscreen.lock="fullscreenLoading" type="primary">添加商品</el-button>
      </div>
      </div>
      <div>
        <el-table
          ref="multipleTable"
          :data="infoList"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            :selectable="selectableFun"
            width="55">
          </el-table-column>
          <el-table-column
            align="center"
            prop="id"
            label="ID">
          </el-table-column>
          <el-table-column
            align="center"
            prop="goodsName"
            label="商品名称">
          </el-table-column>
          <el-table-column
            align="center"
            prop="thumb"
            label="商品图">
            <template slot-scope="scope">
              <el-image
                class="mt-table-goods-img"
                :src="scope.row.thumb == null ? imgServer+'no_img.png' : scope.row.thumb"
                :preview-src-list="[scope.row.thumb]"
                fit="contain"></el-image>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="sellPrice"
            label="商品售价">
          </el-table-column>
          <el-table-column
            align="center"
            prop="totalSalesNumber"
            label="销量">
          </el-table-column>
          <el-table-column
            align="center"
            prop="stockNum"
            label="库存">
          </el-table-column>
          <el-table-column
            align="center"
            prop="isShowHome"
            label="首页显示">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isShowHome"
                active-color="#409EFF"
                inactive-color="#CCCCCC"
                @change="switchChangeBtn(scope.row.id)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="sort"
            label="排序">
          </el-table-column>
          <el-table-column
            align="center"
            prop="status"
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1" class="mt-green">开启</span>
              <span v-else class="mt-red">禁用</span>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            width="240"
            label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="detailOpenBtn(scope.row.id)">详情</el-button>
              <el-button type="text" size="small" @click="editBtn(scope.row.id)">编辑</el-button>
              <el-button @click="enableSingleGoodsStatusBtn(scope.row.id,scope.row.status)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">{{scope.row.status == 1 ? '上架' : '下架'}}</el-button>
              <el-button @click="delGoodsBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">删除</el-button>
              <el-button @click="toRecommendBtn(scope.row.id)" type="text" size="small">推荐商品</el-button>
              <el-button @click="toInspectionReportBtn(scope.row.id)" type="text" size="small">检测报告</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="mt-page-bottom flex-end-row">
          <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
        </div>
      </div>
    </el-card>
    <el-drawer
      size="960px"
      :visible.sync="drawer"
      :with-header="false">
      <div class="mt-goods-top">
        <div class="mt-goods-img">
          <img :src="detailInfo.thumb" alt="" />
        </div>
        <div class="mt-goods-single">
          <div class="mt-goods-name">{{detailInfo.goodsName}}</div>
          <div class="mt-goods-id">商品ID：{{detailInfo.goodsId}}</div>
        </div>
        <div class="mt-goods-content">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="基础信息" name="gjcxx">
              <div class="mt-goods-title flex-row-align">
                <div class="bg-theme"></div>基础信息
              </div>
              <div class="mt-goods-row flex-row-align">
                <div class="mt-goods-row-name">商品名称：</div>
                <div class="mt-goods-row-txt">
                  {{detailInfo.goodsName}}
                </div>
              </div>
              <div class="mt-goods-row flex-row">
                <div class="mt-goods-row-name">商品编码：</div>
                <div class="mt-goods-row-txt">
                  {{detailInfo.goodsNo}}
                </div>
              </div>
              <div class="mt-goods-row flex-row">
                <div class="mt-goods-row-name">商品分类：</div>
                <div class="mt-goods-row-txt">
                  {{detailInfo.cateTxt}}
                </div>
              </div>
              <!-- <div class="mt-goods-row flex-row">
                <div class="mt-goods-row-name">商品单位：</div>
                <div class="mt-goods-row-txt">
                  {{detailInfo.apiUnitName}}
                </div>
              </div> -->
              <div class="mt-goods-row flex-row">
                <div class="mt-goods-row-name">商品标签：</div>
                <div class="mt-goods-row-txt">
                  {{detailInfo.goodsTagTxt}}
                </div>
              </div>
              <div class="mt-goods-row flex-row">
                <div class="mt-goods-row-name">商品轮播图：</div>
                <div class="flex-row-align">
                  <el-image
                    v-for="(item,index) in detailInfo.pictureList"
                    :key="index"
                    class="mt-goods-row-img"
                    :src="item"
                    fit="contain"></el-image>
                </div>
              </div>
              <div class="mt-goods-row flex-row">
                <div class="mt-goods-row-name">商品视频：</div>
                <div class="mt-goods-row-txt">
                  {{ detailInfo.goodsVideoUrl }}
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="规格库存" name="gspkc">
              <div class="mt-goods-title flex-row-align">
                <div class="bg-theme"></div>规格库存
              </div>
              <div v-if="detailInfo.goodsSpecSaveDtoList.length == 1">
                <div class="mt-goods-row flex-row-align">
                  <div class="mt-goods-row-name">商品规格：</div>
                  <div class="mt-goods-row-txt">
                    单规格
                  </div>
                </div>
                <div class="mt-goods-row flex-row-align">
                  <div class="mt-goods-row-name">商品规格编码：</div>
                  <div class="mt-goods-row-txt">
                    {{detailInfo.goodsSpecSaveDtoList[0].specNo}}
                  </div>
                </div>
                <div class="mt-goods-row flex-row">
                  <div class="mt-goods-row-name">规格图片：</div>
                  <div class="flex-row-align">
                    <el-image
                      class="mt-goods-row-img"
                      :src="detailInfo.goodsSpecSaveDtoList[0].thumb"
                      fit="contain"></el-image>
                  </div>
                </div>
                <div class="mt-goods-row flex-row-align">
                  <div class="mt-goods-row-name">商品售价：</div>
                  <div class="mt-goods-row-txt">
                    ¥ {{ detailInfo.goodsSpecSaveDtoList[0].sellPrice }}
                  </div>
                </div>
                <div class="mt-goods-row flex-row-align">
                  <div class="mt-goods-row-name">划线价：</div>
                  <div class="mt-goods-row-txt">
                    ¥ {{ detailInfo.goodsSpecSaveDtoList[0].linePrice }}
                  </div>
                </div>
                <div class="mt-goods-row flex-row-align">
                  <div class="mt-goods-row-name">重量(kg)：</div>
                  <div class="mt-goods-row-txt">
                    {{ detailInfo.goodsSpecSaveDtoList[0].weight }}
                  </div>
                </div>
                <div class="mt-goods-row flex-row-align">
                  <div class="mt-goods-row-name">体积(m³)：</div>
                  <div class="mt-goods-row-txt">
                    {{ detailInfo.goodsSpecSaveDtoList[0].volume }}
                  </div>
                </div>
              </div>
              <div v-if="detailInfo.goodsSpecSaveDtoList.length > 1">
                <div class="mt-goods-row flex-row-align">
                  <div class="mt-goods-row-name">商品规格：</div>
                  <div class="mt-goods-row-txt">
                    多规格
                  </div>
                </div>
                <div class="mt-goods-row2 flex-row">
                  <div class="mt-goods-row-name">规格属性：</div>
                  <div class="mt-goods-row-txt2" style="max-width: 700px;">
                    <el-table
                      :data="detailInfo.goodsSpecSaveDtoList"
                      border
                      style="width: 100%;">
                      <el-table-column
                        prop="specName"
                        label="规格">
                      </el-table-column>
                      <el-table-column
                        prop="specNo"
                        label="商品规格编码"
                        width="110">
                      </el-table-column>
                      <el-table-column
                        prop="thumb"
                        label="图片">
                        <template slot-scope="scope">
                          <el-image
                            class="mt-goods-row-img"
                            :src="scope.row.thumb"
                            fit="contain"></el-image>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="sellPrice"
                        label="售价">
                      </el-table-column>
                      <el-table-column
                        prop="linePrice"
                        label="划线价">
                      </el-table-column>
                      <el-table-column
                        prop="stockNum"
                        label="库存">
                      </el-table-column>
                      <el-table-column
                        prop="weight"
                        label="重量(kg)">
                      </el-table-column>
                      <el-table-column
                        prop="volume"
                        label="体积(m³)">
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="商品详情" name="gspxq">
              <div class="mt-goods-title flex-row-align">
                <div class="bg-theme"></div>商品详情
              </div>
              <div class="mt-goods-detail">
                <div v-html="detailInfo.goodsDetail"></div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="物流设置" name="gwlsz">
              <div class="mt-goods-title flex-row-align">
                <div class="bg-theme"></div>物流设置
              </div>
              <div class="mt-goods-row2 flex-row">
                <div class="mt-goods-row-name2">配送方式：</div>
                <div class="mt-goods-row-txt2">
                  {{detailInfo.expressDelivery == 1 ? '快递配送' : ''}}{{detailInfo.expressDelivery == 1 && detailInfo.pickupDelivery == 1 ? '、' : ''}}{{detailInfo.pickupDelivery == 1 ? '自提' : ''}}
                </div>
              </div>
              <div class="mt-goods-row2 flex-row">
                <div class="mt-goods-row-name2">运费模板：</div>
                <div class="mt-goods-row-txt2">
                  {{ detailInfo.moveTemplateName }}
                </div>
              </div>
              <div class="mt-goods-row2 flex-row">
                <div class="mt-goods-row-name2">包邮方式 ：</div>
                <div class="mt-goods-row-txt2">
                  {{ detailInfo.shipMethod }}
                </div>
              </div>
              <div class="mt-goods-row2 flex-row">
                <div class="mt-goods-row-name2">计费方式 ：</div>
                <div class="mt-goods-row-txt2">
                  {{detailInfo.chargeMethod == 1 ? '按件数' : detailInfo.chargeMethod ==  2 ? '按重量' : '按体积'}}
                </div>
              </div>
              <div class="mt-goods-row2 flex-row">
                <div class="mt-goods-row-name2">运费：</div>
                <div class="mt-goods-row-txt2">
                  <el-table
                    :data="detailInfo.goodsMoveTemplateChargePageVoList"
                    border
                    style="width: 100%">
                    <el-table-column
                      prop="chargeType"
                      label="送达到"
                      width="180">
                      <template slot-scope="scope">
                        <span v-for="(item,index) in scope.row.areaPageVoList" :key="index">{{item.areaName}}</span>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="firstArticle"
                      width="120"
                      :label="detailInfo.chargeMethod == 1 ? '首件' : detailInfo.chargeMethod ==  2 ? '首重量(KG)' : '首件体积(m³)'">
                    </el-table-column>
                    <el-table-column
                      prop="firstMoveMoney"
                      label="运费(元)">
                    </el-table-column>
                    <el-table-column
                      prop="continueArticle"
                      width="120"
                      :label="detailInfo.chargeMethod == 1 ? '续件' : detailInfo.chargeMethod ==  2 ? '续重量(KG)' : '续件体积(m³)'">
                    </el-table-column>
                    <el-table-column
                      prop="continueArticle"
                      label="续费(元)">
                    </el-table-column>
                  </el-table>
                </div>
              </div>
              <div class="mt-goods-row-line"></div>
              <div class="mt-goods-row2 flex-row">
                <div class="mt-goods-row-name2">自提点 ：</div>
                <div>
                  <div v-for="(item,index) in pickData" :key="index" class="mt-goods-row-txt2">
                    {{item.pickupName}}
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="营销设置" name="gyxsz">
              <div class="mt-goods-title flex-row-align">
                <div class="bg-theme"></div>营销设置
              </div>
              <div class="mt-goods-row flex-row-align">
                <div class="mt-goods-row-name">虚拟销量：</div>
                <div class="mt-goods-row-txt">
                  {{detailInfo.virtualSalesNumber}}
                </div>
              </div>
              <div class="mt-goods-row flex-row-align">
                <div class="mt-goods-row-name">排序 ：</div>
                <div class="mt-goods-row-txt">
                  {{detailInfo.sort}}
                </div>
              </div>
              <div class="mt-goods-row flex-row-align">
                <div class="mt-goods-row-name">参与分佣 ：</div>
                <div class="mt-goods-row-txt">
                  {{detailInfo.enableShar == 1 ? '参与' : '不参与'}}
                </div>
              </div>
              <div class="mt-goods-row flex-row-align">
                <div class="mt-goods-row-name">参与折扣：</div>
                <div class="mt-goods-row-txt">
                  {{detailInfo.enableDiscount == 1 ? '参与' : '不参与'}}
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { queryShopGoodsPageList, removeShopGoodsById, fetchShopGoodsDetailById, searchCateInfo, updateShopGoodsStatus, batchUpdateGoodsStatus, updateShopGoodsShowHome, queryWebPickupAddressList } from '@/api/goods'
export default {
  name: 'ShopGoodsList',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      searchForm: {
        name:'',
        cateId:''
      },
      activeName:'gjcxx',
      /* 搜索上的分类数据 */
      cateOptions:[],
      multipleSelection: [],
      limitLength: this.$limitLength,
      pageTotal: 0,
      infoList:[],
      currentPage: 1,
      // 商品详情信息
      drawer: false,
      detailInfo:{
        thumb: "",
        goodsVideoUrl: "",
        goodsNo: "",
        goodsName: "",
        unitName: "",
        categoryTreePageVoList: [],
        pictureList: [],
        goodsLabelPageVoList: [],
        id: "",
        status: "",
        sort: "",
        enableDiscount: "",
        enableShar: "",
        virtualSalesNumber: "",
        pickupDelivery: "",
        expressDelivery: "",
        moveTemplateId: "",
        moveTemplateName: "",
        goodsSpecSaveDtoList: [],
        goodsDetail: "",
        shipMethod:"",
        chargeMethod:"",
        goodsMoveTemplateChargePageVoList:[]
      },
      pickData:[]
    }
  },
  mounted () {
    this.currentPage = Number(this.$route.query.page) || 1
    this.searchCateFun();
    this.getInfoList();
  },
  methods: {
    /* 跳转推荐页面 */
    toRecommendBtn(infoId){
      this.$router.push({path: '/goods_recommend_goods_list', query: {dataId: infoId}})
    },
    /* 跳转检测报告页面 */
    toInspectionReportBtn(infoId){
      this.$router.push({path: '/goods_inspection_report_list', query: {dataId: infoId}})
    },
    /* 跳转编辑页面 */
    editBtn(infoId){
      this.$router.push({path: '/shop_goods_add', query: {dataId: infoId}})
    },
    /* 表格中的复选框开启和禁用 */
    selectableFun(row,index){
      return true;
    },
    /* 表格中复选框选中监听操作 */
    handleSelectionChange (val) {
      var valIdArr = [];
      val.forEach(item => {
        valIdArr.push(item.id);
      })
      this.multipleSelection = valIdArr
    },
    /* 删除操作 */
    delGoodsBtn(infoId){
      var that = this;
      this.$confirm('是否删除当前选择的商品？', '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      })
        .then(() => {
          // 执行保存相关操作
          that.fullscreenLoading = true;
          removeShopGoodsById({ids:[infoId]}).then((res) => {
            that.fullscreenLoading = false;
            if (res.errorCode === '0000') {
              that.getInfoList();
            }
            if (res.errorCode === '1001') {
              that.$message.error(res.msg);
            }
          });
        })
        .catch(action => {
          if(action === 'cancel'){
            // 执行打印相关操作
          }
        });
    },
    // 开启或禁用操作
    switchChangeBtn(infoId){
      let that = this
      updateShopGoodsShowHome({ id: infoId}).then((res) => {
          if (res.errorCode === '0000') {
            this.$message({
              message: res.msg,
              type: 'success',
              onClose () {}
            })
          }
          if (res.errorCode === '1001') {
            this.$message.error(res.msg)
          }
        })
    },
    /* 单个商品上下架操作 */
    enableSingleGoodsStatusBtn(infoId,status){
      var that = this;
      var statusTxt = '是否下架已选中的商品？';
      if(status == 1){
        statusTxt = '是否上架已选中的商品？';
      }
      this.$confirm(statusTxt, '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      })
        .then(() => {
          // 执行保存相关操作
          that.fullscreenLoading = true;
          updateShopGoodsStatus({id:infoId}).then((res) => {
            that.fullscreenLoading = false;
            if (res.errorCode === '0000') {
              that.$message.success(res.msg);
              that.getInfoList();
            }
            if (res.errorCode === '1001') {
              that.$message.error(res.msg);
            }
          });
        })
        .catch(action => {
          // console.log(action)
          if(action === 'cancel'){
            // 执行打印相关操作
          }
      });
    },
    /* 批量上下架操作 */
    enableGoodsStatusBtn(multipleSelection,status){
      var that = this;
      if(multipleSelection.length == 0){
        that.$message.error('请先选中商品');
        return false;
      }
      var statusTxt = '是否下架已选中的商品？';
      if(status == 1){
        statusTxt = '是否上架已选中的商品？';
      }
      this.$confirm(statusTxt, '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      })
        .then(() => {
          // 执行保存相关操作
          that.fullscreenLoading = true;
          batchUpdateGoodsStatus({idList:multipleSelection,status:status}).then((res) => {
            that.fullscreenLoading = false;
            if (res.errorCode === '0000') {
              that.$message.success(res.msg);
              that.getInfoList();
            }
            if (res.errorCode === '1001') {
              that.$message.error(res.msg);
            }
          });
        })
        .catch(action => {
          // console.log(action)
          if(action === 'cancel'){
            // 执行打印相关操作
          }
      });
    },
    /* 商品详情的tab选项卡监听操作 */
    handleClick (tab, event) {
      // console.log(tab, event)
    },
    /* 商品详情-打开操作 */
    detailOpenBtn(dataId){
      var that = this;
      fetchShopGoodsDetailById({id:dataId}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data;
          var cateTxt = '';
          data.categoryTreePageVoList.forEach((item, index) => {
            item.children.forEach(item2 => {
              cateTxt += item.text+'-'+item2.text+'、';
            })
          });
          data.cateTxt = cateTxt == '' ? '--' : cateTxt.substring(0, cateTxt.length - 1);
          var goodsTagTxt = '';
          data.goodsLabelPageVoList.forEach((item) => {
            goodsTagTxt += item.label+'、';
          });
          data.goodsTagTxt = goodsTagTxt == '' ? '--' : goodsTagTxt.substring(0, goodsTagTxt.length - 1);
          if(data.goodsDetail != null){
            data.goodsDetail = data.goodsDetail.replace(/<img([\s\w"-=\/\.:;]+)/ig, '<img$1 style="width: 100%;display:block;"');
          }
          that.detailInfo = data;
          that.pickDataFun();
          that.drawer = true;
        }
        if (res.errorCode === '1001') {
          that.$message.error(res.msg);
        }
      });
    },
    // 自提点列表数据
    pickDataFun(){
      var that = this;
      queryWebPickupAddressList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data;
          that.pickData = data;
        }
      });
    },
    /* 搜索上的分类数据 */
    searchCateFun(){
      var that = this;
      searchCateInfo().then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data;
          data.unshift({
            value: '0',
            label: '全部'
          })
          that.cateOptions = data;
        }
        if (res.errorCode === '1001') {
          that.$message.error(res.msg);
        }
      });
    },
    /* 搜索上的分类数据-监听改变操作 */
    searchCateChangeBtn(value){
      this.searchForm.cateId = value[1];
    },
    /* 搜索操作 */
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let categoryId = that.searchForm.cateId
      let searchName = that.searchForm.name
      let page = that.currentPage
      queryShopGoodsPageList({ categoryId:categoryId, goodsName: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
          if (res.errorCode === '0000') {
            let data = res.data
            data.forEach(function(item) {
              item.isShowHome = item.isShowHome == 1 ? true : false;
            });
            that.infoList = data
            that.pageTotal = res.total
            that.currentPage = page;
          }
          if (res.errorCode === '4002') {
            that.infoList = []
            that.pageTotal = res.total
          }
        })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      // 更新路由参数保存页码
      this.$router.replace({
        query: {
          ...this.$route.query,
          page: val.page
        }
      })
      this.getInfoList();
    }
  }
}
</script>
<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/goods/shop/List.vue